/**
 * File: waitlistModal.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.0.2
 * Created: 2025-12-31
 * Last Updated: 2026-02-18
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Contact Modal
export const waitlistModal = {
    id: "waitlist-modal",
    formHeader: {
        header: "Priority Access",
        subheader: "Be the first to know when our next product drops.",
    },
    textButton: {
        text: "Save My Spot",
        type: "primary",
    },
};
